<template>
	<div style="height: calc(100% - 90px);">
		<div>
			<s-menu :collapsed="collapsed" :menu="menus" theme="dark" mode="inline" @select="onSelect" @click="onClick" style="padding: 16px 0px;"></s-menu>
		</div>
	</div>
</template>

<script>
	import SMenu from './menu.js'
	export default {
		components: {
			SMenu
		},
		data() {
			return {
				routerArr: [],
				collapsed: false,
				menus: [],
				adminSf: '',
				dadminSf: ''
			}
		},
		created() {
			this.getRouter()
		},
		watch: {
			$route(to, from) {
				this.menus = this.menuChangeFun(this.menus)
			}
		},
		methods: {
			getRouter() {
				var menus = [{
						path: '/',
						name: 'index',
						meta: {
							title: '首页',
							icon: 'home'
						},
					},
					{
						path: '/goods',
						meta: {
							title: '商品管理',
							icon: 'appstore'
						},
						children: [{
							path: '/goods/goodsClass',
							name: 'goodsClass',
							meta: {
								title: '商品分类'
							}
						}, {
							path: '/goods/goodsList',
							name: 'goodsList',
							meta: {
								title: '商品管理'
							}
						}]
					},
					// {
					// 	path: '/saleGoods/saleGoodsList',
					// 	name: 'saleGoodsList',
					// 	meta: {
					// 		title: '天天特价',
					// 		icon: 'money-collect'
					// 	},
					// },
					{
						path: '/order/orderList',
						name: 'orderList',
						meta: {
							title: '订单管理',
							icon: 'container'
						},
					},
					// {
					// 	path: '/door/doorList',
					// 	name: 'doorList',
					// 	meta: {
					// 		title: '门店管理',
					// 		icon: 'shop'
					// 	},
					// },
					// {
					// 	path: '/member',
					// 	meta: {
					// 		title: '会员管理',
					// 		icon: 'crown'
					// 	},
					// 	children: [{
					// 		path: '/member/memberClass',
					// 		name: 'memberClass',
					// 		meta: {
					// 			title: '会员类型'
					// 		}
					// 	}, {
					// 		path: '/member/memberList',
					// 		name: 'memberList',
					// 		meta: {
					// 			title: '会员管理'
					// 		}
					// 	}]
					// },
					// {
					// 	path: '/recharge',
					// 	meta: {
					// 		title: '充值管理',
					// 		icon: 'wallet'
					// 	},
					// 	children: [{
					// 		path: '/recharge/rechargeClass',
					// 		name: 'rechargeClass',
					// 		meta: {
					// 			title: '充值方案'
					// 		}
					// 	}, {
					// 		path: '/recharge/rechargeList',
					// 		name: 'rechargeList',
					// 		meta: {
					// 			title: '充值记录'
					// 		}
					// 	}]
					// },
					{
						path: '/coupon/couponList',
						name: 'couponList',
						meta: {
							title: '优惠券管理',
							icon: 'tags'
						},
					},
					// {
					// 	path: '/integral',
					// 	meta: {
					// 		title: '积分商城',
					// 		icon: 'gift'
					// 	},
					// 	children: [{
					// 		path: '/integral/integralList',
					// 		name: 'integralList',
					// 		meta: {
					// 			title: '商品管理'
					// 		}
					// 	}, {
					// 		path: '/integral/integralOrderList',
					// 		name: 'integralOrderList',
					// 		meta: {
					// 			title: '订单管理'
					// 		}
					// 	}]
					// },
					// {
					// 	path: '/cityinfo',
					// 	meta: {
					// 		title: '同城信息',
					// 		icon: 'file-text'
					// 	},
					// 	children: [{
					// 		path: '/cityinfo/cityinfoClass',
					// 		name: 'cityinfoClass',
					// 		meta: {
					// 			title: '信息分类'
					// 		}
					// 	}, {
					// 		path: '/cityinfo/cityinfoList',
					// 		name: 'cityinfoList',
					// 		meta: {
					// 			title: '信息管理'
					// 		}
					// 	}]
					// },
					{
						path: '/userList',
						name: 'userList',
						meta: {
							title: '用户管理',
							icon: 'user'
						},
					},
					{
						path: '/adminList',
						name: 'adminList',
						meta: {
							title: '管理员管理',
							icon: 'key'
						},
					},
					{
						path: '/advList',
						name: 'advList',
						meta: {
							title: '广告管理',
							icon: 'picture'
						},
					},
					// {
					// 	path: '/config',
					// 	name: 'config',
					// 	meta: {
					// 		title: '系统设置',
					// 		icon: 'setting'
					// 	},
					// },
				];
				this.menus = this.menuChangeFun(menus)
			},
			menuChangeFun(menus) {
				let path = this.$route.path
				return menus
			},
			onSelect(obj) {
				// console.log(obj)
			},
			onClick(obj) {
				// console.log(obj)
			},
		}
	}
</script>

<style scoped="scoped">

</style>
